import React, { useEffect, useState } from "react";
import { useRouter } from "next/router";
import { CognitoUser } from "@aws-amplify/auth";

// ui
import { SignInForm } from "./SignInForm";
import { getAPIUserSummary } from "@/api/api-users/useCurrentUser";
import { getEnvConfig } from "@/config/environments";
import { newAPIClient } from "@/libs/axios";
import { SetPasswordForm } from "../set-password/SetPasswordView";
import { FullScreenLoader } from "@/components";
import { MFACodeView } from "../mfa";

export const SignInView = () => {
  const router = useRouter();

  const secondaryView = router?.query["v"];

  const isNewUser = secondaryView === "set-password";
  const isMFA = secondaryView === "2fa-code";

  const to = router?.query?.to;
  const config = getEnvConfig();
  const [user, setUser] = useState<CognitoUser>();

  return (
    <>
      <div className="flex flex-col h-screen relative">
        <div className="flex flex-col items-center justify-center flex-1">
          <div className="flex flex-col max-w-xs w-full px-6 items-center justify-center flex-1 min-h-24">
            <div className="items-center w-full mx-auto">
              {isNewUser ? (
                <SetPasswordForm to={to?.toString()} user={user} />
              ) : isMFA ? (
                <MFACodeView user={user} />
              ) : (
                <SignInForm onSignIn={setUser} to={to?.toString()} />
              )}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default SignInView;
